import { saveAs } from 'file-saver';

import { authService } from '../../services/authService';

// Печать протокола живёт на сервере (bit-export): html2canvas рисовал PDF
// картинкой — без текстового слоя, с разрывами посреди строк, — а .docx собирал
// самописный конвертер, знавший ровно один уровень списка. Теперь оба формата
// печатает pandoc (и WeasyPrint для PDF) из одного и того же markdown.
// Разбор вариантов: docs/2026-09-10-выгрузка-протокола-pdf-и-word.md
// Сервис зовём через свой nginx (/export-api → bit-export); публичного домена
// у него нет намеренно, как у бота встреч.
const EXPORT_URL = '/export-api/export';

async function exportOnServer(markdown, format, filename, title) {
  const response = await fetch(EXPORT_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authService.getAuthHeaders() },
    body: JSON.stringify({ markdown, format, filename, title }),
  });
  if (!response.ok) {
    // Сервис отвечает содержательно (413 — документ длиннее потолка, 504 — не
    // успел собраться), и человеку это полезнее общего «не получилось».
    let detail = '';
    try {
      detail = (await response.json()).detail || '';
    } catch (e) {
      detail = '';
    }
    throw new Error(detail || `Не удалось собрать документ (${response.status})`);
  }
  saveAs(await response.blob(), filename);
}

export async function exportToDocx(text, filename = 'document.docx', title = null) {
  await exportOnServer(text, 'docx', filename, title);
}

/** PDF собирается из ТЕКСТА, а не из узла на экране.
 *
 * Раньше печатали то, что видно: html2canvas снимал бокс узла, и всё, что
 * шире контейнера, в файл не попадало. Теперь оба формата собираются из одного
 * источника — исходного markdown, — и расходиться между собой не могут.
 */
export async function exportToPdf(text, filename = 'document.pdf', title = null) {
  await exportOnServer(text, 'pdf', filename, title);
}

/** PDF со страницы общей ссылки — без входа: bit-export сам берёт текст по токену ссылки
 * (обращение d8f798a9, #67). Ошибку отдаём текстом сервиса, как и exportOnServer. */
export async function exportSharedPdf(shareToken, part, filename) {
  const response = await fetch(
    `/export-api/shared/${encodeURIComponent(shareToken)}/pdf?part=${encodeURIComponent(part)}`);
  if (!response.ok) {
    let detail = '';
    try {
      detail = (await response.json()).detail || '';
    } catch (e) {
      detail = '';
    }
    throw new Error(detail || `Не удалось собрать документ (${response.status})`);
  }
  saveAs(await response.blob(), filename);
}

/** Текстовый файл собирается в браузере: субтитры, markdown, JSON (обращение 6f371de1). */
export function exportToFile(content, filename, type = 'text/plain;charset=utf-8') {
  saveAs(new Blob([content || ''], { type }), filename);
}

export function exportToTxt(text, filename = 'document.txt') {
  exportToFile(text, filename);
}
